import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const postSeverityRuleData = async (customer, data) => {
  const response = await axios({
    url: `/rule/${customer}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  });
  return response.data;
};

const usePostSeverityRule = (customer) => {
  return useMutation((data) => postSeverityRuleData(customer, data));
};

export default usePostSeverityRule;
